import StoreModule from "@/utils/StoreModule";

const customsNationalities = StoreModule("/customs/customs-nationalities");

export default customsNationalities;
